import React, { useState, useEffect } from 'react';
import { getClients } from '../../services/clientService';
import ClientList from '../../components/clients/ClientList';
import ClientSearchBar from '../../components/clients/ClientSearchBar';
import { Link } from 'react-router-dom';
import './Clients.css';

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  
  useEffect(() => {
    fetchClients();
  }, []);
  
  useEffect(() => {
    // Filtrar clientes basado en el término de búsqueda
    if (searchTerm.trim() === '') {
      setFilteredClients(clients);
    } else {
      const filtered = clients.filter(client => 
        client.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.phone.includes(searchTerm) ||
        (client.email && client.email.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredClients(filtered);
    }
  }, [searchTerm, clients]);
  
  const fetchClients = async () => {
    try {
      setLoading(true);
      const data = await getClients();
      setClients(data || []);
      setFilteredClients(data || []);
      setError(null);
    } catch (err) {
      setError('Error al cargar los clientes');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  const handleSearch = (term) => {
    setSearchTerm(term);
  };
  
  return (
    <div className="clients-container">
      <div className="clients-header">
        <h1 className="page-title">Clientes</h1>
        <Link to="/clients/new" className="new-client-button">
          Nuevo Cliente
        </Link>
      </div>
      
      <ClientSearchBar onSearch={handleSearch} />
      
      {loading ? (
        <div className="loading-state">
          <p>Cargando clientes...</p>
        </div>
      ) : error ? (
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchClients}>Reintentar</button>
        </div>
      ) : (
        <ClientList clients={filteredClients} />
      )}
    </div>
  );
};

export default Clients;